import { Container } from "@/theme1/components/common/Container";
import { Sparkles } from "lucide-react";

export function TopBar() {
    return (
        <div className="border-b border-white/10 bg-black text-white">
            <Container className="py-2">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex min-w-0 items-center gap-3">
                        <span className="inline-flex size-7 shrink-0 items-center justify-center rounded-full bg-white/10 text-white">
                            <Sparkles className="size-3.5" />
                        </span>
                        <p className="truncate text-[10px] font-black uppercase tracking-[0.24em] text-white/85 sm:text-xs">
                            Free delivery on orders over 1999
                        </p>
                    </div>

                    <div className="hidden items-center gap-2 md:flex">
                        <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-white/75">
                            New drops
                        </span>
                        <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-white/75">
                            Fast support
                        </span>
                    </div>
                </div>
            </Container>
        </div>
    );
}
